import { useSubscription } from '@apollo/client/react';
import { ScoAttachmentUserPresenceSubscriptionPayload } from '@src/graphql-types';
import { useWsReconnected } from '@src/hooks/useWsReconnected';
import { gql } from '@src/lib/gql';
import { useEffect, useState } from 'react';
export const useAttachmentUserPresences = (attachmentType: string, attachmentId: string) => {
  const [presences, setPresences] = useState<{
    [key: string]: ScoAttachmentUserPresenceSubscriptionPayload;
  }>({});
  const subscription = useSubscription(gql`
      subscription ($attachmentType: String!, $attachmentId: String!) {
        scoAttachmentUserPresence(attachmentId: $attachmentId, attachmentType: $attachmentType) {
          key
          user {
            id
            pictureUrl
            fullName
            displayName
          }
          isTyping
          isOnline
        }
      }
    `, {
    variables: {
      attachmentId: attachmentId,
      attachmentType: attachmentType
    }
  });

  // Presence is event-only. A "stopped typing" sent while the socket was down never arrives,
  // so forget what we knew on reconnect rather than show a stale typing row.
  useWsReconnected(() => setPresences({}));
  useEffect(() => {
    if (subscription.data?.scoAttachmentUserPresence) {
      setPresences({
        ...presences,
        [subscription.data?.scoAttachmentUserPresence.key]: subscription.data?.scoAttachmentUserPresence
      });
    }
  }, [subscription.data]);
  return presences;
};